// Global Instructions Rule Applied!

import {
  FilterValue,
  SortConfig,
  SetFilterOptionsAction,
  SetContactsAction,
  SetActiveFiltersAction,
  SetActiveSortingAction,
  ClearActiveFiltersAction,
  UpdateContactRecordAction,
  AddContactAction,
  AppendContactsAction,
  RemoveContactFromListAction
} from '../../interfaces/contacts.ts'
import { ContactsPaginatedResponse } from '../../../app_modules/contacts/services/contactsService.ts'
import { TableFilterOptionsResponse } from '../../rpc_models/get_table_filter_options_response.ts'
import { ContactRecord } from '../../data_models/contact_record.ts'
import {
  SET_FILTER_OPTIONS,
  SET_CONTACTS,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  UPDATE_CONTACT_RECORD,
  ADD_CONTACT,
  APPEND_CONTACTS,
  REMOVE_CONTACT_FROM_LIST
} from './constants.ts'

export const setFilterOptions = ({ response }: { response: TableFilterOptionsResponse }): SetFilterOptionsAction => ({
  type: SET_FILTER_OPTIONS,
  payload: { response }
})

export const setContacts = ({ response }: { response: ContactsPaginatedResponse }): SetContactsAction => ({
  type: SET_CONTACTS,
  payload: { response }
})

export const setActiveFilters = ({ filters }: { filters: FilterValue[] }): SetActiveFiltersAction => ({
  type: SET_ACTIVE_FILTERS,
  payload: { filters }
})

export const setActiveSorting = ({ sorting }: { sorting: SortConfig[] }): SetActiveSortingAction => ({
  type: SET_ACTIVE_SORTING,
  payload: { sorting }
})

export const clearActiveFilters = (): ClearActiveFiltersAction => ({
  type: CLEAR_ACTIVE_FILTERS,
  payload: {}
})

export const updateContactRecord = ({
  contactId,
  updates
}: {
  contactId: string
  updates: Record<string, any>
}): UpdateContactRecordAction => ({
  type: UPDATE_CONTACT_RECORD,
  payload: { contactId, updates }
})

export const addContact = ({ contact }: { contact: ContactRecord }): AddContactAction => ({
  type: ADD_CONTACT,
  payload: { contact }
})

export const appendContacts = ({ response }: { response: ContactsPaginatedResponse }): AppendContactsAction => ({
  type: APPEND_CONTACTS,
  payload: { response }
})

export const removeContactFromList = ({
  contactId
}: {
  contactId: string
}): RemoveContactFromListAction => ({
  type: REMOVE_CONTACT_FROM_LIST,
  payload: { contactId }
})
